import { mapGetters } from 'vuex'
import { wordCount } from '../lib/utils'

/**
 * Get the PostResource Mixin adjusted by options
 *
 * @param {bool} [options.postRequired=true] - if the post prop should be required
 * @param {bool} [options.includeAuthor=true] - if the mixin should include the author
 * @param {bool} [options.includeTags=true] - if the mixin should include tags
 * @param {bool} [options.includeTributes=true] - if the mixin should include tributes
 *
 * @return {object} PostResourceMixin
 */
export const getPostResourceMixin = ({
  postRequired = true,
  includeAuthor = true,
  includeTags = true,
  includeTributes = true,
} = {}) => ({
  props: {
    post: {
      type: Object,
      required: postRequired,
    },
  },
  computed: {
    ...mapGetters([
      // only need this if we are including the author
      ...(includeAuthor ? ['getUser'] : []),
      // only need this if we are including tributes
      ...(includeTributes ? ['getPostsTributes'] : []),
    ]),
    author: !includeAuthor
      ? undefined
      : function() {
          return this.getUser(this.post ? this.post.authorId : null)
        },
    tags: !includeTags
      ? undefined
      : function() {
          return this.post && this.post.tags ? this.post.tags.split(' ') : []
        },
    tributes: !includeTributes
      ? undefined
      : function() {
          return this.getPostsTributes(this.post ? this.post.id : null)
        },
    timeToRead() {
      const rawContent = `${this.post.title} ${this.post.subtitle ||
        ''} ${this.post.sections.reduce((acc, s) => {
        acc += ' ' + typeof s === 'string' ? s : s.content || ''
        return acc
      }, '')}`
      const words = wordCount(rawContent)
      const wpm = 200
      const estimate = words / wpm
      const minutes = Math.round(estimate)
      return minutes < 1 ? '< 1 min read' : `${minutes} min read`
    },
    isAuthor() {
      return this.post.authorId === this.$currentUser.id
    },
    hasImage() {
      return this.post && this.post.img
    },
    route() {
      return {
        name: 'postById',
        params: { id: this.post.id },
      }
    }
  },
  methods: {
    gotoPost() {
      this.$router.push(this.route)
    },
  },
})

export default getPostResourceMixin()
